export default class ServiceValue {
  constructor(titles = {}, serviceValueInfos = []) {
      this.titles = titles; // Multilingual titles
      this.serviceValueInfos = serviceValueInfos; // Array of service value info objects
  }

  isValid() {
      let result = true;

        if (this.titles === null || this.titles === undefined) {
            result = false;
        }
        if (this.serviceValueInfos === null || this.serviceValueInfos === undefined) {
            result = false;
        }

      return result;
  }
}